import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77f5da54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, "邓氏桂圆", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-r" }, null, -1))

import MenuPhone from './MenuPhone.vue'
import router from '@/router/index'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHeader',
  setup(__props) {

const store = useStore()
const isMobile = store.state.isMobile
const onHome = () => {
  router.push('/')
}



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['homeHeaderWrap', { 'phone': _unref(isMobile) }])
  }, [
    _createElementVNode("div", {
      class: "logoWrap",
      onClick: onHome
    }, [
      _createVNode(_component_el_image, {
        src: require(`/public/images/common/logo.png`),
        class: "logo"
      }, null, 8, ["src"]),
      _hoisted_1
    ]),
    _createVNode(MenuPhone),
    _hoisted_2
  ], 2))
}
}

})